import { getAttachmentUrl } from "@portal/api/download";
import { useMutation } from "@tanstack/react-query";

function usePreviewAttachmentQuery() {
  return useMutation({
    mutationKey: ["preview-attachment"],
    mutationFn: (id: string) => getAttachmentUrl(id),
    onSuccess() {},
    onError() {},
  });
}

export { usePreviewAttachmentQuery };
